module.exports = __webpack_public_path__ + "static/media/profilePhoto.bf583ca2.JPG";